import { FC, useState } from 'react';
import { Button, Form, FormField, Heading, Input } from '@livechat/design-system-react-components';

import { SigninFormData, FormStates } from 'types/form';
import { Layout } from 'components/layout/Layout';
import { PasswordRequirements } from 'components/password-requirements/PasswordRequirements';

import * as styles from './styles';

type Props = {
  formData: SigninFormData;
  onPasswordInputChange: (e: any) => void;
  onSubmit: (e: any) => Promise<void>;
  formState: string;
  validationError: string;
};

export const NewPassword: FC<Props> = ({
  formData,
  onPasswordInputChange,
  onSubmit,
  formState,
  validationError,
}) => {
  const { password } = formData;
  const [showErrors, setShowErrors] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (validationError) {
      setShowErrors(true);
      return;
    }
    await onSubmit(e);
  };

  return (
    <Layout showHeaderLogo showGoToSignIn>
      <div css={styles.container} data-testid="new-password-form">
        <Heading size="lg">Change your password</Heading>
        <Form onSubmit={handleSubmit}>
          <FormField
            labelText="New password"
            labelFor="password"
            css={styles.formField}
            error={
              showErrors && !!validationError ? 'Meet all password rules below' : validationError
            }
          >
            <Input
              type="password"
              name="password"
              placeholder="Enter new password"
              inputSize="large"
              value={password || ''}
              onChange={onPasswordInputChange}
              error={showErrors && !!validationError}
            />
          </FormField>
          <PasswordRequirements password={password} showErrors={showErrors} />

          <Button
            kind="primary"
            size="large"
            css={styles.button}
            type="submit"
            loading={formState === FormStates.Requesting}
          >
            Change password
          </Button>
        </Form>
      </div>
    </Layout>
  );
};
